import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const CookieContext = createContext();

export const COOKIE_TYPES = {
  NECESSARY: 'necessary',
  ANALYTICS: 'analytics',
  MARKETING: 'marketing',
  PREFERENCES: 'preferences'
};

export const CookieProvider = ({ children }) => {
  const [showConsent, setShowConsent] = useState(false);
  const [preferences, setPreferences] = useState({
    [COOKIE_TYPES.NECESSARY]: true, // Always true as these are essential
    [COOKIE_TYPES.ANALYTICS]: false,
    [COOKIE_TYPES.MARKETING]: false,
    [COOKIE_TYPES.PREFERENCES]: false,
  });

  useEffect(() => {
    // Check if user has already made their choice
    const consent = Cookies.get('cookie-consent');
    if (!consent) {
      setShowConsent(true);
    } else {
      try {
        const savedPreferences = JSON.parse(consent);
        setPreferences(savedPreferences);
      } catch (error) {
        console.error('Error parsing cookie preferences:', error);
        setShowConsent(true);
      }
    }
  }, []);

  const handleAcceptAll = () => {
    const allAccepted = {
      [COOKIE_TYPES.NECESSARY]: true,
      [COOKIE_TYPES.ANALYTICS]: true,
      [COOKIE_TYPES.MARKETING]: true,
      [COOKIE_TYPES.PREFERENCES]: true,
    };
    setPreferences(allAccepted);
    Cookies.set('cookie-consent', JSON.stringify(allAccepted), { expires: 365 });
    setShowConsent(false);
  };

  const handleDeclineAll = () => {
    const allDeclined = {
      [COOKIE_TYPES.NECESSARY]: true, // Necessary cookies are always accepted
      [COOKIE_TYPES.ANALYTICS]: false,
      [COOKIE_TYPES.MARKETING]: false,
      [COOKIE_TYPES.PREFERENCES]: false,
    };
    setPreferences(allDeclined);
    Cookies.set('cookie-consent', JSON.stringify(allDeclined), { expires: 365 });
    setShowConsent(false);
  };

  const handleSavePreferences = (newPreferences) => {
    const updatedPreferences = {
      ...newPreferences,
      [COOKIE_TYPES.NECESSARY]: true, // Ensure necessary cookies are always true
    };
    setPreferences(updatedPreferences);
    Cookies.set('cookie-consent', JSON.stringify(updatedPreferences), { expires: 365 });
    setShowConsent(false);
  };

  const value = {
    showConsent,
    preferences,
    handleAcceptAll,
    handleDeclineAll,
    handleSavePreferences,
    setShowConsent,
  };

  return (
    <CookieContext.Provider value={value}>
      {children}
    </CookieContext.Provider>
  );
};

export const useCookies = () => {
  const context = useContext(CookieContext);
  if (context === undefined) {
    throw new Error('useCookies must be used within a CookieProvider');
  }
  return context;
};

export default CookieContext; 